<template>
  <v-container fluid>
    <div id="mapDiv"></div>
    <v-row align="start" justify="end">
      <v-card :width="$vuetify.breakpoint.lgAndUp ? 80 : 50"
      color="black" class="text-center">
        <v-img width=80 :src=newFenceButtonImage @click="newFence"/>
        <span class="body-2 white--text">Set new fence</span>
        <!-- <v-img v-show="newFenceCircle === null" width=80 src="/button_gallery.png" />
        <span v-show="newFenceCircle === null" class="body-2 white--text">Gallery</span> -->
        <v-img v-show="newFenceCircle"
        width=80 src="/button_new_fence_save.png" @click="showSaveFenceDialog" />
        <span v-show="newFenceCircle" class="body-2 white--text">Save fence</span>
        <v-img v-show="newFenceCircle"
        width=80 src="/button_new_fence_cancel.png" @click="cancelFence" />
        <span v-show="newFenceCircle" class="body-2 white--text">Cancel</span>
      </v-card>
      <v-snackbar v-model="saveSnackbar">
        Remember to save new geofence.
      </v-snackbar>
      <v-dialog max-width="300" v-model="saveFenceDialog">
        <v-card>
          <v-card-title class="headline">Save fence</v-card-title>
          <v-text-field class="ma-2" label="Name" v-model="nameField"></v-text-field>
          <v-text-field class="ma-2" label="Radius (m)" v-model="radiusField"></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="saveFenceDialog = false">Cancel</v-btn>
            <v-btn @click="saveFence">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="radiusWarningSnackbar">
        Radius cannot be under 10m.
      </v-snackbar>
      <v-snackbar v-model="nameWarningSnackbar">
        Name cannot be empty.
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<style scoped>
#mapDiv {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
}
</style>

<script>

import gql from 'graphql-tag';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const SUBSCRIPTION_GEOFENCES = gql`
subscription get_geofences($deviceId: String!) {
  geofences (
    where: {
      device_id: {
        _eq: $deviceId
      }
    }
  ) {
    id
    enabled
    location
    radius
  }
}
`;

const ADD_GEOFENCE = gql`
  mutation addGeofence ($deviceId: String!, $location: geometry!, $radius: Int!, $name: String!) {
    insert_geofences_one(object: {
      device_id: $deviceId
      location: $location
      enabled: true
      radius: $radius
      name: $name
    }) {
      id
    }
  }
`;

const UPDATE_USER_MAPLAYER = gql`
mutation update_user_maplayer($sub: String!, $map_layer: String!) {
  update_users_by_pk(
    pk_columns: { sub: $sub },
    _set: {
      map_layer: $map_layer
    }
  ) {
    map_layer
  }
}
`;

export default {
  name: 'Geolapse',
  data() {
    return {
      map: null,
      markers: null,
      settingFence: false,
      deviceId: null,
      geofences: null,
      centerOnce: true,
      ignoreLayerSelectionOnce: true,
      newFenceCircle: null,
      draggingCircle: false,
      saveSnackbar: false,
      saveFenceDialog: false,
      nameField: 'Fence name',
      radiusField: 50,
      radiusWarningSnackbar: false,
      nameWarningSnackbar: false,
    };
  },
  computed: {
    newFenceButtonImage() {
      if (this.settingFence) {
        return '/button_new_fence_selected.png';
      }
      return '/button_new_fence.png';
    },
  },
  methods: {
    newFence() {
      if (this.newFenceCircle) {
        return;
      }
      this.settingFence = !this.settingFence;
    },
    setNewFence(e) {
      if (!this.settingFence) {
        return;
      }
      this.settingFence = false;
      this.saveSnackbar = true;

      this.newFenceCircle = L.circle([e.latlng.lat,
        e.latlng.lng], {
        radius: 100, fillOpacity: 0.25, color: '#00ff00',
      }).addTo(this.markers);

      this.newFenceCircle.on('click', this.circleMouseClick);
    },
    mapMouseMove(e) {
      this.newFenceCircle.setLatLng(e.latlng);
    },
    circleMouseClick() {
      if (this.draggingCircle) {
        this.map.off('mousemove');
      } else {
        this.map.on('mousemove', this.mapMouseMove);
      }

      this.draggingCircle = !this.draggingCircle;
    },
    showSaveFenceDialog() {
      if (this.$store.state.newGeofenceRadius > 0) {
        this.radiusField = this.$store.state.newGeofenceRadius;
      }
      this.saveFenceDialog = true;
    },
    cancelFence() {
      this.settingFence = false;
      this.newFenceCircle = null;
      this.updateMarkers();
    },
    saveFence() {
      const radius = this.radiusField;
      const name = this.nameField;

      if (radius < 10) {
        this.radiusWarningSnackbar = true;
        return;
      }
      this.$store.commit('newGeofenceRadius', this.radiusField);

      if (name === null || name.length < 1) {
        this.nameWarningSnackbar = true;
        return;
      }

      this.saveFenceDialog = false;
      const coord = this.newFenceCircle.getLatLng();

      const location = {
        type: 'Point',
        coordinates: [coord.lat, coord.lng],
      };

      // eslint-disable-next-line
      const deviceId = this.deviceId;

      this.$apollo.mutate({
        mutation: ADD_GEOFENCE,
        variables: {
          deviceId,
          location,
          radius,
          name,
        },
        // eslint-disable-next-line
        update: (cache, { data: { insert_geofences_one } }) => {
        },
      });

      this.settingFence = false;
      this.newFenceCircle = null;
      this.updateMarkers();
    },
    editFence(e) {
      this.$store.commit('currentGeofenceId', e.target.geofenceId);
      this.$store.commit('currentMapZoomLevel', this.map.getZoom());
      this.$store.commit('cameFromView', 'Geolapse');
      this.$router.push({ name: 'Geofence' });
    },
    updateMarkers() {
      this.markers.clearLayers();

      let totalLat = 0;
      let totalLng = 0;
      let fenceCount = 0;

      this.geofences.forEach((geofence) => {
        if (geofence && geofence.location && geofence.location.coordinates) {
          const marker = L.circle([geofence.location.coordinates[0],
            geofence.location.coordinates[1]], {
            radius: geofence.radius, fillOpacity: 0.25, color: geofence.enabled ? '#00ff00' : '#808080',
          }).addTo(this.markers);
          marker.on('click', this.editFence);
          marker.geofenceId = geofence.id;
          totalLat += geofence.location.coordinates[0];
          totalLng += geofence.location.coordinates[1];
          fenceCount += 1;
        }
      });

      if (this.centerOnce) {
        if (this.$store.state.currentMapZoomLevel > 0) {
          this.map.setZoom(this.$store.state.currentMapZoomLevel);
        }
        if (this.$store.state.currentMapLocation) {
          this.map.panTo(this.$store.state.currentMapLocation);
          this.centerOnce = false;
        }
        if (this.centerOnce) {
          if (fenceCount > 0) {
            const avgLat = totalLat / fenceCount;
            const avgLng = totalLng / fenceCount;

            this.map.setView(new L.LatLng(avgLat, avgLng), 12);
          } else {
            this.map.setView(new L.LatLng(64.7914001, 25.4080717), 12);
          }
        }
        this.centerOnce = false;
      }
    },
    layerSelected(e) {
      if (this.ignoreLayerSelectionOnce) {
        this.ignoreLayerSelectionOnce = false;
        return;
      }
      // eslint-disable-next-line
      console.log('selected layer: ' + e.name);
      this.$store.commit('mapLayer', e.name);
      this.saveMapLayer();
    },
    saveMapLayer() {
      // eslint-disable-next-line
      const sub = this.$store.state.user.attributes.sub;
      // eslint-disable-next-line
      const map_layer = this.$store.state.mapLayer;

      const variables = {
        sub,
        map_layer,
      };

      this.$apollo.mutate({
        mutation: UPDATE_USER_MAPLAYER,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_users } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
  },
  mounted() {
    this.deviceId = this.$store.state.currentDeviceId;

    // eslint-disable-next-line
    const mapBoxSatellite = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    // eslint-disable-next-line
    const mapBoxStreets = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    const openStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const maanmittauslaitos = L.tileLayer('https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/maastokartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png', { id: 'Maastokartta' });

    let defaultLayerName = this.$store.state.mapLayer;
    if (defaultLayerName === undefined || defaultLayerName === null) {
      console.log('defaultti');
      defaultLayerName = 'Maanmittauslaitos';
    } else {
      console.log(defaultLayerName);
    }

    const mapLayers = {
      // eslint-disable-next-line
      'MapBoxSatellite': mapBoxSatellite,
      // eslint-disable-next-line
      'MapBoxStreets': mapBoxStreets,
      // eslint-disable-next-line
      'OpenStreetMap': openStreetMap,
      // eslint-disable-next-line
      'Maanmittauslaitos': maanmittauslaitos,
    };

    this.map = L.map('mapDiv', {
      minZoom: 4,
      maxZoom: 18,
      zoomControl: false,
      layers: [mapLayers[defaultLayerName]],
    });
    this.map.on('baselayerchange ', this.layerSelected);

    L.control.layers(mapLayers, null, { position: 'topleft' }).addTo(this.map);

    this.markers = new L.FeatureGroup();
    this.map.addLayer(this.markers);
    this.map.on('click', this.setNewFence);
  },
  apollo: {
    $subscribe: {
      geofences: {
        query: SUBSCRIPTION_GEOFENCES,
        variables() {
          return {
            deviceId: this.deviceId,
          };
        },
        result(data) {
          this.geofences = data.data.geofences;
          this.updateMarkers();
        },
      },
    },
  },
};
</script>
